function readApiError(res, fallback) {
  if (res?.logout) return "Session expired. Please sign in again.";
  return res?.data?.msg || res?.error || fallback;
}

async function clippingGet(hitAxios, path) {
  const res = await hitAxios({
    path,
    post: false,
    showLoading: false,
    showSnackbar: false,
  });
  if (res?.logout) throw new Error("Session expired. Please sign in again.");
  if (!res?.data?.success) throw new Error(readApiError(res, "Request failed."));
  return res.data.data;
}

async function clippingMutate(hitAxios, { path, method = "POST", body }) {
  const res = await hitAxios({
    path,
    post: method !== "GET",
    method,
    obj: body,
    showLoading: false,
    showSnackbar: false,
    timeout: 120000,
  });
  if (res?.logout) throw new Error("Session expired. Please sign in again.");
  if (!res?.data?.success) throw new Error(readApiError(res, "Request failed."));
  return res.data.data;
}

export function fetchClippingTemplates(hitAxios) {
  return clippingGet(hitAxios, "/api/clipping/assets/templates");
}

export function fetchClippingMusic(hitAxios) {
  return clippingGet(hitAxios, "/api/clipping/assets/music");
}

export function fetchClippingGameVideos(hitAxios) {
  return clippingGet(hitAxios, "/api/clipping/assets/game-videos");
}

export function fetchClippingMemeHooks(hitAxios) {
  return clippingGet(hitAxios, "/api/clipping/assets/meme-hooks");
}

export function createClippingJob(hitAxios, payload) {
  return clippingMutate(hitAxios, { path: "/api/clipping/create", body: payload });
}

export function fetchClippingStatus(hitAxios, requestId) {
  return clippingGet(hitAxios, `/api/clipping/${encodeURIComponent(requestId)}/status`);
}

export function fetchClippingResult(hitAxios, requestId) {
  return clippingGet(hitAxios, `/api/clipping/${encodeURIComponent(requestId)}`);
}

export function deleteClippingJob(hitAxios, requestId) {
  return clippingMutate(hitAxios, {
    path: `/api/clipping/${encodeURIComponent(requestId)}`,
    method: "DELETE",
  });
}
